
        import '/home/builduser/work/575538235ca6a4de/santa-editor/packages/wixData/components/collectionsList/actionButtons.scss.css.virtualfile';
        module.exports = {"buttonContainer":"_buttonContainer_rl8r3_7"};